import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import {
  IAddRole,
  IRoleSearchList,
  IUpdateRole,
} from "../../Shared/Types/role";
import { IReducerWithCallback } from "../../Shared/Types/shared";
import { MODULES, PERMISSIONS } from "Shared/Types/permissions";
import { ASSIGNMENTS, DASHBOARD } from "Shared/Constants/routes";

const getRolesList = createAsyncThunk(
  "role/getRoles",
  async (params: IRoleSearchList | null) => {
    try {
      const response = await api.role.getRoleList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const addRole = createAsyncThunk(
  "role/addRole",
  async ({ data, onError, onSuccess }: IReducerWithCallback<IAddRole>) => {
    try {
      const response = await api.role.addRole(data);
      onSuccess?.();
      return response.data;
    } catch (error: any) {
      onError?.(error?.response?.data);
      console.error(error);
      throw error;
    }
  }
);

const updateRole = createAsyncThunk(
  "role/updateRole",
  async ({ data, onError, onSuccess }: IReducerWithCallback<IUpdateRole>) => {
    try {
      const response = await api.role.updateRole(data);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      console.error(error);
      throw error;
    }
  }
);

const getPermissionList = createAsyncThunk(
  `account/getPermissionList`,
  async (params?: { refreshQuery: string }) => {
    try {
      const response = await api.role.getPermissionList(params);
      const permissions: Set<PERMISSIONS> = new Set();
      const modules: Set<MODULES> = new Set();
      response.data.modules.forEach((item) => {
        modules.add(item.code_name as MODULES);
        if (item.permissions) {
          item.permissions.forEach((el) => {
            permissions.add(el.codename as PERMISSIONS);
            if (el.sub_permissions) {
              el.sub_permissions.forEach((e) => {
                permissions.add(e.codename as PERMISSIONS);
              });
            }
          });
        }
      });

      return {
        ...response.data,
        available_permissions: permissions,
        modules,
        default_route: modules.has(MODULES.DASHBOARDS)
          ? DASHBOARD
          : ASSIGNMENTS,
      };
    } catch (error) {
      console.error(error);
    }
  }
);

export { addRole, updateRole, getRolesList, getPermissionList };
